import { render, staticRenderFns } from "./TrainingSelectBooksSlider.vue?vue&type=template&id=ee1da3dc&scoped=true&"
import script from "./TrainingSelectBooksSlider.vue?vue&type=script&lang=js&"
export * from "./TrainingSelectBooksSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1da3dc",
  null
  
)

export default component.exports